import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {Col, Container, Form} from "react-bootstrap";
import React, {Fragment, useEffect, useState} from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import {Card, CardBody, FormGroup, Input, Label, Nav, Row} from "reactstrap";
import withReducer from "../../../store/withReducer";
import Tooltip from "@material-ui/core/Tooltip";
import * as SweetAlert from "sweetalert2";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import leadReducer from "../store";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import {mapBuyerLeadResponseToTable} from "../../../utils/mapper";
import defaultAvatar from "../../../assets/images/user/user.png";
import {
    deleteBuyerLead,
    getAllBuyerLeads,
    getBuyerLeadSettings,
    selectBuyerLead, setBuyerFilter, setSaveState,
    setSettings,cancelSubscriptionBuyerLead
} from "../store/buyerLeadSlice";
import PreLoader from "../../../share-components/ui/preLoader";
import Select from "react-select";
import {buyerFilters} from "../../manage-product/product/edit/content/settings/map";


const dataMenu = [
    {
        type: 0,
        text: 'Leads',
        link: '/leads/buyer-lead'
    },
    {
        type: 1,
        text: 'Buyer Leads',
        link: ''
    },
];

const customStyles = {
    control: base => ({
        ...base,
        minHeight: 50,
        border: 'none',
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999,
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999,
    }),
};

const submitTypes = ["submit", "update", "save"];
const BuyerLead = () => {

    const dispatch = useDispatch();
    let history = useHistory();
    const [differentPage, setDifferentPage] = useState(!submitTypes.includes(history.location.state?.from));
    const [timer, setTimer] = useState(null);
    const buyerLead = useSelector(selectBuyerLead);
    const currentUser = useSelector(({authReducer}) => authReducer.data.user);
    const buyerLeadState = useSelector(({lead}) => lead.buyerLead);
    const [loading, isSetLoading] = useState(history.location.state?.from !== "update" || buyerLead.length < 1);
    const [isFilterable, setIsFilterable] = useState((history.location.state?.from !== "update" || buyerLead.length < 1));
    const [previewImage, setPreviewImage] = useState(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    useEffect(()=> {
        if (!submitTypes.includes(history.location.state?.from)) {
            dispatch(setBuyerFilter(buyerFilters()));
        }
    }, [dispatch]);

    useEffect(() => {

        if (isFilterable || buyerLeadState.saveState) {
            const filter = buyerLeadState.filter;
            if (differentPage && JSON.stringify(filter) != JSON.stringify(buyerFilters())) {
                setDifferentPage(false);
            } else {
                dispatch(getAllBuyerLeads({
                    page_size: filter.pageSize,
                    page: filter.currentPage,
                    name: buyerLeadState.filter.name,
                    email: buyerLeadState.filter.email,
                    pageSize: filter.pageSize,
                    mobile: filter.mobile,
                    country: buyerLeadState.filter.country?buyerLeadState.filter.country.id: '',
                    type: buyerLeadState.filter.type? buyerLeadState.filter.type.value: '',
                    customerRepresentative: buyerLeadState.filter.customerRepresentative?buyerLeadState.filter.customerRepresentative.id:'' ,
                    is_vip: filter.is_vip,

                })).then(res=> {
                    isSetLoading(false);
                })
                setDifferentPage(false);
            }
            dispatch(setSaveState(false));
        }
        setIsFilterable(true);

    }, [buyerLeadState.filter.currentPage, buyerLeadState.filter.pageSize, buyerLeadState.filter.email, buyerLeadState.filter.name, buyerLeadState.filter.mobile,
        buyerLeadState.filter.type, buyerLeadState.filter.country, buyerLeadState.filter.customerRepresentative,buyerLeadState.filter.is_vip,]);

    useEffect(() => {
        dispatch(getBuyerLeadSettings()).then(res=> {
            dispatch(setSettings(res.payload))
        });
    },[dispatch]);

    const onPageSizeChange=(e)=>{
        dispatch(setBuyerFilter({...buyerLeadState.filter, currentPage: 1, pageSize:e}))
    }

    const pageChange = (event) => {
        dispatch(setBuyerFilter({...buyerLeadState.filter, currentPage:event}))
    }
    
    const cancelSubscription = (row) => {
        SweetAlert.fire({
          title: "Confirm Subscription Cancellation",
          text: "Are you sure you want to cancel this subscription? This action cannot be undone.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Cancel Subscription",
          cancelButtonText: "No, Keep Subscription",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(cancelSubscriptionBuyerLead(row.id)).then(res => {
              if (!res.error) {
                dispatch(
                  setBuyerFilter({
                    ...buyerLeadState.filter,
                    is_vip: false,
                    currentPage: 1,
                  })
                );
              }
            });            
          }
        });
      };
      

    const onAdd = () => {
        history.push('/leads/buyer-lead/create');
    }

    const onEdit = (row) => {
        history.push('/leads/buyer-lead/'+row.id+ '/edit');
    }
    const onView = (row) => {
        history.push('/leads/buyer-lead/' + row.id + '/view');
    }
    const onDelete = (row) => {
        dispatch(deleteBuyerLead(row.id))
    };

    const otherMarketPlaceOptions = [
        {value: '1', label: 'Customer'},
        {value: '2', label: 'Lead'},
    ]

    const hasUpdatePermission = currentUser.permission.includes("Update Buyer Lead");
    const hasDeletePermission = currentUser.permission.includes("Delete Buyer Lead");
    const isVipCustomer = (value) => value === 1 || value === "1" || value === true;

    const actionContainerStyle = {
        display: "grid",
        gridAutoFlow: "column",
        gridTemplateColumns: "repeat(4, 34px)",
        gap: 6,
        alignItems: "center",
        justifyContent: "center",
    };

    const actionButtonStyle = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 34,
        height: 34,
    };
    const actionIconStyle = {
        fontSize: 16,
    };
    const selectMenuPortalTarget = typeof document !== "undefined" ? document.body : null;
    const formatVipValidity = (value) => {
        if (value === null || value === undefined) {
            return "—";
        }
        const text = String(value).trim();
        if (!text) {
            return "—";
        }
        return text;
    };

    const tableColumns = [
        {
          name: "Customer Name",
          cell: (row) => {
            const customerName = row.display_name || row.name || `Buyer #${row.id}`;
            return (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <img
                src={row.profile_image || defaultAvatar}
                alt={customerName ? `${customerName} avatar` : "Customer avatar"}
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  objectFit: "cover",
                  cursor: row.profile_image ? "pointer" : "default",
                }}
                title={row.profile_image ? "View profile image" : undefined}
                role={row.profile_image ? "button" : undefined}
                tabIndex={row.profile_image ? 0 : undefined}
                onClick={(event) => {
                  if (!row.profile_image) {
                    return;
                  }
                  event.preventDefault();
                  event.stopPropagation();
                  setPreviewImage(row.profile_image);
                  setIsPreviewOpen(true);
                }}
                onKeyDown={(event) => {
                  if (!row.profile_image) {
                    return;
                  }
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    setPreviewImage(row.profile_image);
                    setIsPreviewOpen(true);
                  }
                }}
              />
              <div
                style={{
                  fontWeight: "bold",
                  maxWidth: 160,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={customerName}
              >
                {customerName}
              </div>
            </div>
          )},
          sortable: false,
          left: true,
          minWidth: "220px",
          maxWidth: "240px",
        },
      
        {
          name: "Email",
          cell: (row) => (
            <div
              style={{
                maxWidth: 220,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={row.email || ""}
            >
              {row.email}
            </div>
          ),
          sortable: false,
          left: true,
          minWidth: "240px",
          maxWidth: "260px",
        },
      
        {
          name: "Phone Number",
          selector: (row) => row.mobile_number,
          sortable: false,
          left: true,
        },
      
        {
          name: "VIP Customer",
          // elector: (row) => row.name,
          cell: (row) => (
            <div>
              <div style={{ fontSize: "0.9em", color: "gray", paddingTop: 5 }}>
                  {isVipCustomer(row.is_vip_customer) ? "Yes" : "No"}
              </div>
            </div>
          ),
          sortable: false,
          left: true,
        },
        {
          name: "VIP Validity",
          cell: (row) => {
              const validity = formatVipValidity(row.vip_validity);
              const hasValue = validity !== "—";
              return (
                  <span
                      title={hasValue ? validity : "No VIP validity"}
                      style={{
                          display: "inline-block",
                          minWidth: 16,
                          fontSize: "0.9em",
                          color: hasValue ? "#232323" : "#9ca3af",
                          fontWeight: hasValue ? 400 : 600,
                          letterSpacing: hasValue ? 0 : "0.08em",
                      }}
                  >
                      {validity}
                  </span>
              );
          },
          sortable: false,
          left: true,
        },
      
        {
          name: "country",
          selector: (row) => row.country,
          sortable: false,
          left: true,
        },
      
        {
          name: "Buyer Type",
          selector: (row) => row.buyer_type,
          sortable: false,
          left: true,
        },
      
        {
          name: "Date",
          selector: (row) => row.date,
          sortable: false,
          left: true,
        },
      
        {
          name: "Action",
          selector: (row) => (
            <div style={actionContainerStyle}>
              <a
                onClick={() => {
                  onView(row);
                }}
                style={actionButtonStyle}
              >
                <i
                  className="fa fa-eye"
                  style={{
                    ...actionIconStyle,
                    color: "rgb(80,126,83)",
                  }}
                ></i>
              </a>

              {hasUpdatePermission ? (
                <a
                  onClick={() => {
                    onEdit(row);
                  }}
                  style={actionButtonStyle}
                >
                  <i
                    className="fa fa-pencil"
                    style={{
                      ...actionIconStyle,
                      color: "rgb(40, 167, 69)",
                    }}
                  ></i>
                </a>
              ) : (
                ""
              )}
      
              {hasDeletePermission ? (
                <a
                  onClick={() => {
                    onDelete(row);
                  }}
                  style={actionButtonStyle}
                >
                  <i
                    className="fa fa-trash"
                    style={{
                      ...actionIconStyle,
                      color: "red",
                    }}
                  ></i>
                </a>
              ) : (
                ""
              )}
      
              {hasUpdatePermission && isVipCustomer(row.is_vip_customer) ? (
                <Tooltip title="Cancel Subscription" arrow>
                  <a
                    onClick={() => {
                      cancelSubscription(row);
                    }}
                    style={actionButtonStyle}
                  >
                    <i
                      className="fa fa-credit-card-alt"
                      style={{
                        ...actionIconStyle,
                        color: "rgb(208,179,29)",
                      }}
                    ></i>
                  </a>
                </Tooltip>
              ) : (
                ""
              )}
            </div>
          ),
          sortable: false,
          minWidth: "180px",
          center: true,
        },
      ];
      

    return (
        <Fragment>

            <Container fluid={true}>
                {loading ? <><PreLoader></PreLoader></> : <>
                <Breadcrumb data={dataMenu} title="Buyer Leads"/>
                <div className="product-grid">
                    <div className="feature-products">
                        <Row>
                            <Col sm="12">
                                <Card>
                                    <Row>
                                        <Col sm="6">
                                            <Nav tabs className="border-tab">

                                            </Nav>
                                        </Col>
                                        <Col sm="6">
                                            <div className='float-sm-right p-3'>
                                                <a className="btn btn-sm btn-primary"
                                                   onClick={() => {
                                                       onAdd();
                                                   }}
                                                > <i className="fa fa-plus"></i> Add Buyer Lead</a>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <Row className="align-items-end mb-1">
                            <Col sm="12" xl="4" className="mb-3">
                                <Form>
                                    <FormGroup>
                                        <Input
                                            defaultValue={buyerLeadState.filter.name}
                                            onChange={(e) => {
                                                clearTimeout(timer);
                                                const newTimer = setTimeout(()=>{
                                                    dispatch(setBuyerFilter({
                                                        ...buyerLeadState.filter,
                                                        name:e.target.value,
                                                        currentPage: 1
                                                    }));
                                                },500)
                                                setTimer(newTimer);
                                            }}
                                            name="name"
                                            type="text" className="form-control"
                                            placeholder="Search By Name"/>
                                    </FormGroup>
                                </Form>
                            </Col>
                            <Col sm="12" xl="4" className="mb-3">
                                <Form>
                                    <FormGroup>
                                        <Input
                                            defaultValue={buyerLeadState.filter.email}
                                            onChange={(e) => {
                                                dispatch(setBuyerFilter({
                                                    ...buyerLeadState.filter,
                                                    email:e.target.value,
                                                    currentPage: 1
                                                }));
                                            }}
                                            name="name"
                                            type="text" className="form-control"
                                            placeholder="Search By Email"/>
                                    </FormGroup>
                                </Form>
                            </Col>
                            <Col sm="12" xl="4" className="mb-3">
                                <Form>
                                    <FormGroup>
                                        <Input
                                            defaultValue={buyerLeadState.filter.mobile}
                                            onChange={(e) => {
                                                dispatch(setBuyerFilter({
                                                    ...buyerLeadState.filter,
                                                    mobile:e.target.value,
                                                    currentPage: 1
                                                }));
                                            }}
                                            name="name"
                                            type="number" className="form-control"
                                            placeholder="Search By Mobile"/>
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>
                        <Row className="align-items-end mb-2">
                            <Col sm="12" xl="4" className="mb-3">
                                <FormGroup>
                                    <Select
                                        placeholder={<div>Buyer Type</div>}
                                        className="select2-filter"
                                        isClearable
                                        styles={customStyles}
                                        defaultValue={buyerLeadState.filter.type}
                                        menuPortalTarget={selectMenuPortalTarget}
                                        menuPosition="fixed"
                                        options={otherMarketPlaceOptions}
                                        onChange={(e) => {
                                            dispatch(setBuyerFilter({
                                                ...buyerLeadState.filter,
                                                type:e?e:null,
                                                currentPage: 1
                                            }));
                                        }}

                                    />
                                </FormGroup>
                            </Col>
                            <Col sm="12" xl="4" className="mb-3">
                                <FormGroup>
                                    <Select
                                        placeholder={<div>Country</div>}
                                        className="select2-filter"
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        isClearable
                                        // cacheOptions
                                        styles={customStyles}
                                        defaultValue={buyerLeadState.filter.country}
                                        menuPortalTarget={selectMenuPortalTarget}
                                        menuPosition="fixed"
                                        options={buyerLeadState.settings.countries}
                                        onChange={(e) => {
                                            dispatch(
                                                setBuyerFilter({
                                                    ...buyerLeadState.filter,
                                                    country:e,
                                                    currentPage: 1
                                                }));
                                        }}

                                    />
                                </FormGroup>
                            </Col>
                            <Col sm="12" xl="4" className="mb-3">
                                <FormGroup>
                                    <Select
                                        placeholder={<div>Customer Representative</div>}
                                        className="select2-filter"
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        isClearable
                                        // cacheOptions
                                        styles={customStyles}
                                        defaultValue={buyerLeadState.filter.customerRepresentative}
                                        menuPortalTarget={selectMenuPortalTarget}
                                        menuPosition="fixed"
                                        options={buyerLeadState.settings.customerRepresentative}
                                        onChange={(e) => {
                                            dispatch(setBuyerFilter({
                                                ...buyerLeadState.filter,
                                                customerRepresentative: e,
                                                currentPage: 1
                                            }));
                                        }}

                                    />
                                </FormGroup>
                            </Col>
                            <Col sm="12" xl="4" className="mb-3 d-flex align-items-center">
                            <FormGroup check>
                                <Label check>
                                <Input
                                    type="checkbox"
                                    checked={buyerLeadState.filter.is_vip || false}
                                    onChange={(e) => {
                                    dispatch(
                                        setBuyerFilter({
                                        ...buyerLeadState.filter,

                                        is_vip: e.target.checked,

                                        currentPage: 1,
                                        })
                                    );
                                    }}
                                />
                                VIP Customers
                                </Label>
                            </FormGroup>
                            </Col>

                        </Row>
                        <Row>
                            <Col sm="12">
                                <Card>
                                    <CardBody>
                                        <div className="table-responsive product-table">
                                            <CommonDataTable
                                                headerColumns={tableColumns}
                                                gridData={mapBuyerLeadResponseToTable(buyerLead)}
                                                onEdit={(currentUser.permission).includes('Update Buyer Lead') ? onEdit:''}
                                                onDelete={(currentUser.permission).includes('Delete Buyer Lead') ? onDelete:''}
                                                fixedColumns
                                                className="buyer-leads-table"
                                                paginationServer
                                                paginationTotalRows={buyerLeadState.buyerTableRow}
                                                onChangePage={pageChange}
                                                noAction
                                                onChangeRowsPerPage={onPageSizeChange}
                                                paginationDefaultPage={buyerLeadState.filter.currentPage}
                                                paginationPerPage={buyerLeadState.filter.pageSize}
                                            />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
                </> }
            </Container>
            {isPreviewOpen && previewImage && (
                <Lightbox
                    mainSrc={previewImage}
                    onCloseRequest={() => {
                        setIsPreviewOpen(false);
                        setPreviewImage(null);
                    }}
                />
            )}
        </Fragment>
    );
}

export default withReducer([{lead: leadReducer}])(BuyerLead);
